var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainerUnknown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 76,
    viewBox: "0 0 75 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.203125,
    width: 75,
    height: 75,
    fill: "#F8F8F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.703125,
    width: 74,
    height: 74,
    stroke: "black",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 31.2031H25V45.2031H26V31.2031Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 31.2031H28.5V45.2031H29.5V31.2031Z",
    fill: "#CCCCCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31.2031H33V45.2031H34V31.2031Z",
    fill: "#CCCCCC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 31.2031H37.5V45.2031H38.5V31.2031Z",
    fill: "#CCCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31.2031H42V45.2031H43V31.2031Z",
    fill: "#CCCCCC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 31.2031H46.5V45.2031H47.5V31.2031Z",
    fill: "#CCCCCC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31.2031H50V45.2031H51V31.2031Z",
    fill: "#CCCCCC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2227 29.3984V46.9823",
    stroke: "#CCCCCC",
    strokeWidth: 1.66667,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5557 29.3984V46.9823",
    stroke: "#CCCCCC",
    strokeWidth: 1.66667,
    strokeLinecap: "square"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9447 29.0365H54.8335V47.3698H20.9447V29.0365Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.66667
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M57 47.2031H19V48.2031H57V47.2031Z",
    fill: "#CCCCCC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6893 43.7095C35.7162 42.109 35.8978 40.8447 36.234 39.9166C36.5703 38.9886 37.2562 37.9597 38.2919 36.8299L40.9348 34.1063C42.0646 32.8285 42.6295 31.4567 42.6295 29.9906C42.6295 28.5784 42.2596 27.4721 41.5198 26.6719C40.7801 25.8716 39.7041 25.4715 38.2919 25.4715C36.92 25.4715 35.8171 25.8346 34.9832 26.5609C34.1493 27.2872 33.7323 28.2623 33.7323 29.4862H30C30.0269 27.3074 30.8036 25.5488 32.3302 24.2105C33.8568 22.8722 35.844 22.2031 38.2919 22.2031C40.8339 22.2031 42.8144 22.8857 44.2334 24.2509C45.6523 25.616 46.3618 27.4889 46.3618 29.8696C46.3618 32.2233 45.2724 34.5434 43.0935 36.8299L40.8944 39.0088C39.9126 40.0982 39.4217 41.6651 39.4217 43.7095H35.6893ZM35.5279 50.1049C35.5279 49.4997 35.7128 48.992 36.0827 48.5817C36.4526 48.1715 37.0007 47.9664 37.727 47.9664C38.4533 47.9664 39.0047 48.1715 39.3813 48.5817C39.7579 48.992 39.9462 49.4997 39.9462 50.1049C39.9462 50.7102 39.7579 51.2112 39.3813 51.608C39.0047 52.0047 38.4533 52.2031 37.727 52.2031C37.0007 52.2031 36.4526 52.0047 36.0827 51.608C35.7128 51.2112 35.5279 50.7102 35.5279 50.1049Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerUnknown);
export default __webpack_public_path__ + "static/media/container_Unknown.9374dfcd897c8626fbac91910087cc9d.svg";
export { ForwardRef as ReactComponent };